import { AbstractCodeValue, CodePanel, ConfCodeValue, StoredCodeValue } from "../../models";
import * as Immutable from 'immutable';

// Represents the model for one panel and its values.
export class CodePanelValuesModel {

  panelId: number;

  values: Immutable.List<FileCodeValueModel>

}

export class FileCodeValueModel {

  calcValue: ConfCodeValue;

  storedValue: StoredCodeValue;

}